import { render, staticRenderFns } from "./Office-New-Request-Step4.vue?vue&type=template&id=3623603b&scoped=true&"
import script from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
export * from "./Office-New-Request-Step4.vue?vue&type=script&lang=js&"
import style0 from "./Office-New-Request-Step4.vue?vue&type=style&index=0&id=3623603b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3623603b",
  null
  
)

export default component.exports